/**
 * Shared CSS for surfaces that switch look through CSS variables rather than
 * separate components (search results, bet cards, admin).
 *
 * The pattern: a style value is written `var(--bo-x, <classic value>)`. Classic
 * never defines --bo-x, so the fallback (the exact pre-Floodlight value) wins
 * and Classic stays pixel-identical. Floodlight defines --bo-x only under
 * html[data-ui-style="floodlight"] (one look, dark only since v1.71).
 *
 * Since v1.71 Floodlight keeps the original colours, glass and purple/blue
 * accents on these surfaces, so it defines only type variables here; colour,
 * background and border vars stay undefined and their classic fallbacks win.
 *
 *   import { registerUiStyleCss, uiVar } from '../floodlight/uiStyleCss';
 *   registerUiStyleCss('results', cssText);          // once, idempotent, web only
 *   color: uiVar('card-ink', 'rgba(255,255,255,0.9)')
 */
import { IS_WEB } from '../../utils/motion';

/** `var(--bo-<name>, <fallback>)`. */
export const uiVar = (name, fallback) => `var(--bo-${name}, ${fallback})`;

/** The Floodlight selector, for building the CSS text. */
export const FL_ANY = 'html[data-ui-style="floodlight"]';

/** `{ 'card-ink': '#fff' }` → `--bo-card-ink:#fff;` */
export const varBlock = (vars) => Object.entries(vars).map(([k, v]) => `--bo-${k}:${v};`).join('');

const registered = new Set();

export function registerUiStyleCss(id, cssText) {
    if (!IS_WEB || typeof document === 'undefined' || registered.has(id)) return;
    registered.add(id);
    const el = document.createElement('style');
    el.setAttribute('data-ui-style-css', id);
    el.textContent = cssText;
    document.head.appendChild(el);
}
